module.exports = __webpack_public_path__ + "static/media/cover-contact.ded63c15.png";